import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\talign-items: center;\n\tbackground: ", ";\n\tcolor: ", ";\n\tdisplay: flex;\n\tjustify-content: center;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';
export var Placeholder = css(_templateObject(), ui.get('surfaceBackgroundSubtleColor'), ui.color.text);